import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { FiShoppingCart } from "react-icons/fi";
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx";

const Nav = () => {
  const [showMenu, setShowMenu] = useState(true);
  return (
    <NAV>
      <div className="navbar">
        <ul className="nav-bar-list">
          <li>
            <NavLink to={"/"} className="navbar-link">
              {" "}
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to={"/about"} className="navbar-link">
              {" "}
              About
            </NavLink>
          </li>
          <li>
            <NavLink to={"/contact"} className="navbar-link">
              {" "}
              Contact
            </NavLink>
          </li>
          <li>
            <NavLink to={"/"} className="navbar-link">
              {" "}
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to={"/"} className="navbar-link">
              <FiShoppingCart className="cart" size={24}>
                {" "}
              </FiShoppingCart>
              <span className="cart-quant">10</span>
            </NavLink>
          </li>
        </ul>
        <div className="toggle-btn-container">
          <RxHamburgerMenu color="white" className="hamburger" size={24}>
            {" "}
          </RxHamburgerMenu>
          <RxCross1 color="white" className="hamburger" size={24}>
            {" "}
          </RxCross1>
        </div>
      </div>
    </NAV>
  );
};

const NAV = styled.nav`
  .nav-bar-list {
    display: flex;
    gap: 1rem;
    word-wrap: break-word;
    align-items: center;
    list-style-type: none;
    .navbar-link {
      font-size: small;
      &:link,
      &:visited {
        color: white;
        text-decoration: none;
        display: inline-block;
        list-style-type: none;
      }
    }
    .cart {
      position: relative;
      color: white;
      margin-top: 0.6rem;
      /* background-color: azure; */
    }
    .cart-quant {
      position: absolute;
      color: red;
      /* top: 6%; */
      right: 1%;
      font-size: x-small;
      font-weight: 900;
    }
  }
  .navbar-link {
    color: white;
  }

  .hamburger {
    display: flex;
  }
  .toggle-btn-container {
    display: none;
  }
  @media (max-width: 400px) {
    .toggle-btn-container {
      display: inline-block;
      z-index: 999;
      position: absolute;
      top: 1rem;
      right: 2rem;
    }
    .nav-bar-list {
      /* align-items: center; */
      justify-content: center;
      flex-direction: column;
      width: 100vw;
      height: 100vh;
      /* background-color: red; */
      /* gap: 0.rem; */
    }
    .navbar-link {
      font-size: 22px;
    }
  }
`;

export default Nav;
